import { render } from "./12BasePreview.vue?vue&type=template&id=6276bf56"
const script = {}
script.render = render

export default script